import { Overline, Reveal } from "@/components/Motion";
import { LEGAL } from "@/data/maison";

export default function Legal({ page }) {
  const doc = LEGAL[page];

  return (
    <main className="pt-20">
      <section className="mx-auto max-w-[820px] px-6 md:px-12 py-20 md:py-28" data-testid={`legal-${page}`}>
        <Reveal y={16}>
          <Overline>Maison Ria</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 font-display font-light tracking-tight text-4xl md:text-5xl">
            {doc.title}
          </h1>
          <p className="mt-4 text-sm text-muted-foreground">Dernière mise à jour : septembre 2026</p>
        </Reveal>
        {doc.sections.map((section) => (
          <Reveal key={section.heading} className="mt-12">
            <h2 className="font-display text-2xl">{section.heading}</h2>
            {section.paragraphs.map((p, i) => (
              <p key={i} className="mt-4 font-light text-muted-foreground leading-relaxed">
                {p}
              </p>
            ))}
          </Reveal>
        ))}
      </section>
    </main>
  );
}
